(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"]) return;
  try {
    
  /**
   * Accordion / description tabs — vanilla port of airbag-man global.js initTabs().
   * Scoped via [data-accordion-tabs] so it does not clash with search-form initTabs.
   */
  (() => {
    const activateMatchingTabItems = (type, tabId) => {
      const tabItems = document.querySelectorAll(
        `.${type}-tabs .tab-item, .${type}-tabs-wrapper .tab-item`
      );

      for (const item of tabItems) {
        const link = item.querySelector(`a[data-tab="${tabId}"]`);
        const isMatch = Boolean(link);

        item.classList.toggle('active', isMatch);
        item.classList.toggle('inactive', !isMatch);
        item.classList.remove('initial-active');
      }
    };

    const activateTabContent = (type, tabId) => {
      const tabs = document.querySelectorAll(`.${type}-tab`);

      for (const tab of tabs) {
        const isMatch = tab.classList.contains(tabId);

        tab.classList.toggle('active', isMatch);
        tab.classList.toggle('inactive', !isMatch);
        tab.classList.remove('initial-active');
      }
    };

    const resetTabs = (type) => {
      const tabItems = document.querySelectorAll(
        `.${type}-tabs .tab-item, .${type}-tabs-wrapper .tab-item`
      );
      const tabs = document.querySelectorAll(`.${type}-tab`);

      for (const item of tabItems) {
        item.classList.remove('initial-active', 'active');
        item.classList.add('inactive');
      }

      for (const tab of tabs) {
        tab.classList.remove('initial-active', 'active');
        tab.classList.add('inactive');
      }
    };

    document.addEventListener('click', (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const link = target.closest('[data-accordion-tabs] .tab-item a[data-tab]');

      if (!link) return;

      const wrapper = link.closest('[data-accordion-tabs]');

      if (!(wrapper instanceof HTMLElement)) return;

      const type = wrapper.dataset.accordionTabs;

      if (!type) return;

      event.preventDefault();

      const tabItem = link.closest('.tab-item');
      const isCurrentlyActive = tabItem?.classList.contains('active');
      const tabId = link.getAttribute('data-tab');
      const closeOnActive = wrapper.dataset.closeOnActive === 'true';
      const hasModalOverlay = wrapper.dataset.hasModalOverlay === 'true';

      resetTabs(type);

      if (!closeOnActive || !isCurrentlyActive) {
        if (tabId) {
          activateMatchingTabItems(type, tabId);
          activateTabContent(type, tabId);
        }

        if (hasModalOverlay) {
          document.querySelector('.modal-overlay')?.classList.add('active');
        }

        return;
      }

      if (hasModalOverlay) {
        document.querySelector('.modal-overlay')?.classList.remove('active');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airbagman-search"] && !Shopify.designMode) return;
  try {
    
  /**
   * Center the search on the seam between its neighbors.
   * When the section above has a bottom texture, shift the bar up by that
   * height so the texture's top edge sits at the bar's midpoint.
   */
  (() => {
    const observers = new WeakMap();

    const syncAirbagmanSearchOverlap = (section) => {
      const bar = section.querySelector('.airbagman-search');

      if (!bar) return;

      const height = bar.getBoundingClientRect().height;

      if (!height) return;

      const previous = section.previousElementSibling;
      const next = section.nextElementSibling;
      const texture = previous instanceof HTMLElement
        ? previous.querySelector('.section-bottom-texture')
        : null;
      const textureHeight = texture instanceof HTMLElement
        ? texture.getBoundingClientRect().height
        : 0;
      const overlapStart = height / 2 + textureHeight;
      const overlapEnd = Math.max(height / 2 - textureHeight, 0);

      section.style.setProperty('--airbagman-search-height', `${height}px`);
      section.style.setProperty('--airbagman-search-overlap-start', `${overlapStart}px`);
      section.style.setProperty('--airbagman-search-overlap-end', `${overlapEnd}px`);

      if (previous instanceof HTMLElement) {
        previous.style.setProperty('--airbagman-search-pad-end', `${overlapStart}px`);
      }

      if (next instanceof HTMLElement) {
        next.style.setProperty('--airbagman-search-pad-start', `${overlapEnd}px`);
      }
    };

    const observeAirbagmanSearch = (section) => {
      const bar = section.querySelector('.airbagman-search');

      if (!bar) return;

      let observer = observers.get(section);

      if (!observer) {
        observer = new ResizeObserver(() => {
          syncAirbagmanSearchOverlap(section);
        });
        observers.set(section, observer);
      }

      observer.observe(bar);

      const previous = section.previousElementSibling;
      const texture = previous instanceof HTMLElement
        ? previous.querySelector('.section-bottom-texture')
        : null;

      if (texture) observer.observe(texture);
    };

    const syncAllAirbagmanSearchOverlaps = () => {
      const sections = document.querySelectorAll('.airbagman-search-section');

      for (const section of sections) {
        if (!(section instanceof HTMLElement)) continue;

        syncAirbagmanSearchOverlap(section);
        observeAirbagmanSearch(section);
      }
    };

    syncAllAirbagmanSearchOverlaps();

    document.addEventListener('shopify:section:load', () => {
      syncAllAirbagmanSearchOverlaps();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
